/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';
import { Heading } from '../../display/Heading';

type Props = {
  /**
   * The title of the table and any actions that apply to the entire
   * `Table`, such as a filtering mechanism. These children display
   * in a CSS Grid, so be sure to render them directly into `TableTitleArea`.
   */
  children: React.ReactNode;
  /**
   * The visual rendering of `TableTitleArea`. Matches up with `Table[kind]`.
   */
  kind?: 'standard' | 'custom';
};

const Styles = labelStyles('TableTitleArea', {
  root: css`
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: 20px;
    align-items: center;

    &[data-kind='standard'] {
      padding: 5px 10px;
    }
  `,
  title: css`
    color: ${Colors.gray80};
    ${Typography.sectionHeader3Extrabold};
  `,
});

const defaultProps = {
  kind: 'standard',
};

export const TableTitle = (props: { children: React.ReactNode }) => {
  return <Heading css={Styles.title}>{props.children}</Heading>;
};

/**
 * Displays the title and actions for a `Table`.
 */
export const TableTitleArea = (_props: Props) => {
  const props = {
    ...defaultProps,
    ..._props,
  };
  return (
    <header css={Styles.root} data-kind={props.kind}>
      {props.children}
    </header>
  );
};
